import { processSteps } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function Process() {
  return (
    <section id="process" className="w-full bg-primary-950 py-16 md:py-24">
      <div className="px-4 md:px-10">
        <div className="reveal">
          <SectionHeading
            light
            eyebrow="How We Work"
            title="合作流程"
            subtitle="清晰透明的协作流程，让每一个项目都按计划稳步推进、如期交付。"
          />
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-5">
          {processSteps.map((item, index) => (
            <div key={item.step} className="reveal relative" style={{ transitionDelay: `${index * 70}ms` }}>
              <div className="flex items-center gap-3 mb-5">
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 text-accent-950 font-heading font-bold text-sm">
                  {item.step}
                </span>
                {index < processSteps.length - 1 && (
                  <span className="hidden lg:block flex-1 h-px bg-primary-700"></span>
                )}
              </div>
              <h3 className="font-heading font-semibold text-background-50 text-base md:text-lg">{item.title}</h3>
              <p className="mt-3 text-sm text-background-300 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}